<template>
  <crumbs :zhuantiName="detail.specialTopicName" />
  <div class="mainContainer">
    <show-content :detail="detail" />
  </div>
</template>

<script setup>
import {getZhuanDetail} from "../../../../apis/zhuanti";

const Route = useRoute()
const specialTopicDetailId = ref(Route.params.specialTopicDetailId)
const zhuantiName = ref('')

let detail = ref({})
const zhuantiRes = await useAsyncData('getZhuanDetail2',
    () => getZhuanDetail(specialTopicDetailId.value),
)
if (zhuantiRes.data.value.code !== 200) {
  throw createError({statusCode: zhuantiRes.data.value.code, statusMessage: encodeURIComponent("getZhuanDetail")})
} else {
  detail.value = zhuantiRes.data.value.data
}

</script>

<style scoped>

</style>